module.exports = __webpack_public_path__ + "img/icon-assistant.fe90f648.svg";